var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTrauma64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 43.5109V27.4949C57 25.2597 55.3183 23.3676 53 22.7314V48.2744C55.3183 47.6383 57 45.7462 57 43.5109Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 27.4949V43.5109C7 45.7462 8.68165 47.6383 11 48.2744V22.7314C8.68165 23.3676 7 25.2597 7 27.4949Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1333 16.5029H12.8667C11.8357 16.5029 11 17.4416 11 18.5995V52.4064C11 53.5643 11.8357 54.5029 12.8667 54.5029H51.1333C52.1643 54.5029 53 53.5643 53 52.4064V18.5995C53 17.4416 52.1643 16.5029 51.1333 16.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.1029V16.5029C35.6667 16.5029 43 16.5029 43 16.5029C43 15.0363 43 13.5696 43 12.1029C43 11.2193 42.212 10.5029 41.24 10.5029H22.76C21.788 10.5029 21 11.2193 21 12.1029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3333 25.5029H28.6705V32.1696H22V38.8363H28.6705V45.5029H35.3333V38.8363H42V32.1696H35.3333V25.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTrauma64);
export default __webpack_public_path__ + "static/media/pictogramBeaconTrauma64.0749a73347288ca3d0240ba04f747fa6.svg";
export { ForwardRef as ReactComponent };